import { generateToken } from "./firebase";

const inFlight = new Map();
const lastSync = new Map();
const COOLDOWN_MS = 60 * 1000; // 1 minute cooldown between sync attempts

export async function syncWebToken({ userId, appName, axios }) {
  const key = `${appName || "web"}:${userId || "anon"}`;
  const now = Date.now();
  const last = lastSync.get(key);
  if (last && now - last < COOLDOWN_MS) return true;

  if (inFlight.get(key)) return inFlight.get(key);
  let token = localStorage.getItem("firebaseToken");
  if (!token) {
    token = await generateToken();
  }
  if (!token || !userId) return false;

  lastSync.set(key, now);
  const promise = axios.patch(`/users/${userId}`, {
    fcm_token_web: token,
    token_type: "web",
    app_name: appName,
  }).then(() => true).finally(() => {
    inFlight.delete(key);
  });

  inFlight.set(key, promise);
  return promise;
}

export async function deactivateWebToken({ appName, axios }) {
  const token = localStorage.getItem("firebaseToken");
  if (!token) return false;
  await axios.post("/tokens/deactivate", {
    fcm_web_token: token,
    token_type: "web",
    app_name: appName,
  });
  return true;
}
